<template>
  <div>
    <el-row :gutter="20" v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_edit') === -1 ">
      <el-col :span="4">
        <el-select v-model="fetchParams.status" @change="changeSearch" placeholder="是否有效"
                   style="width: 100%;">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="商品名称" v-model="fetchParams.goods_name"><el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button></el-input>
      </el-col>
      <el-col :span="4">
        <el-input placeholder="合约单号" v-model="fetchParams.order_no"><el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="姓名" v-model="fetchParams.realname"><el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="手机号" v-model="fetchParams.connact_mobile"><el-button slot="append" icon="el-icon-search" @click="searchGoods"></el-button></el-input>
      </el-col>

      <el-col :span="4">
        <el-select  v-model="fetchParams.category_id" clearable placeholder="商品分类" @change="searchGoods">
          <el-option v-for="item in category" :key="item.value" :label="item.name" size="mini" :value="item.category_id"> </el-option>
        </el-select>
      </el-col>
      <el-col :span="6" >
        <el-date-picker v-model="fetchParams.created" type="daterange" start-placeholder="开始日期" ange-separator="至" end-placeholder="结束日期" value-format="yyyy/MM/dd" placeholder="选择日期范围" style="width: 100%;" @change="dateChange" ></el-date-picker>
      </el-col>

    </el-row>
    <div v-if="$route.path.indexOf('_detail') === -1 && $route.path.indexOf('_edit') === -1 ">

      <el-table
        :data="dataList"
        style="width: 100%">
        <el-table-column
          prop="goods_name"
          label="商品名称">
        </el-table-column>
        <el-table-column
          label="用户"
          prop="realname">
        </el-table-column>
        <el-table-column
          label="手机号"
          prop="connact_mobile">
        </el-table-column>
        <el-table-column
          prop="order_no"
          label="合约单号">
        </el-table-column>
        <el-table-column
          prop="is_realname"
          label="是否实名">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.is_realname == 0">否</el-tag>
            <el-tag v-else>是</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="是否有效">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.status == 0">无效</el-tag>
            <el-tag type="success" v-else-if="scope.row.status == 1">有效</el-tag>
            <el-tag v-else>已完成</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="created_text"
          label="签约时间">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="couponlist(scope.row.order_no)">优惠券列表</el-button>
            <el-button type="text" @click="del(scope.row.sign_id,index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="优惠券" :visible.sync="dialogTableVisible">
        <el-table :data="coupondataList" width="90%">
          <el-table-column property="goods_name" label="商品名称"></el-table-column>
          <el-table-column property="realname" label="真实名称"></el-table-column>
          <el-table-column property="level" label="层级"></el-table-column>
          <el-table-column property="connact_mobile" label="手机号"></el-table-column>
          <el-table-column  label="状态" >
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0" style="color: #000">{{scope.row.status_text}}</span>
              <span v-else-if="scope.row.status == 1" style="color: red">{{scope.row.status_text}}</span>
              <span v-else-if="scope.row.status == 2" style="color: green">{{scope.row.status_text}}</span>
              <span v-else-if="scope.row.status == 3" style="color: blue">{{scope.row.status_text}}</span>
              <span v-else style="color: #ccc">{{scope.row.status_text}}</span>
            </template>
          </el-table-column>
          <el-table-column property="order_no" label="合约单号" ></el-table-column>
          <el-table-column property="card_id" label="优惠券id" ></el-table-column>
          <el-table-column property="get_cardlog_code" label="优惠券code"></el-table-column>
          <el-table-column property="begin_time_text" label="开始时间" ></el-table-column>
          <el-table-column property="end_time_text" label="结束时间" ></el-table-column>
          <el-table-column property="expiry_time_text" label="过期时间" ></el-table-column>
        </el-table>
      </el-dialog>
      <div class="content-padded content-center" v-if="pagers.total>0">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page.sync="fetchParams.page"
          :page-sizes="[10,20,50,100]"
          :total="pagers.total"
          :page-size="fetchParams.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getSignList,deleteSign,getCategoryList,getCouponList} from '@/api/long'

export default {
  props: {
    isLoad: {
      type: Boolean,
      default: true
    },
  },
  provide() {
    return {
      refresh: this.getList
    }
  },
  data () {
    return {
      loading: false,
      dataList: [],
      pagers:{
        total: 0
      },
      goods_name:'',
      created:'',
      category:[],
      category_id:'',
      order_no:'',
      connact_mobile:'',
      realname:'',
      status:'',
      options: [
        {value: '', label: '是否有效'},
        {value: 0, label: '无效'},
        {value: 1,label: '有效'},
        {value: 2,label: '完成'}
      ],
      pageSize:20,
      currentPage:1,
      params: {},
      fetchParams: {
        page: 1,
        begin_time:'',
        end_time:'',
        title:'',
        realname:'',
        connact_mobile:'',
        type:'',
        pageSize: 20,
        goods_id:'',
        goods_name:'',
        status:'',
      },
      multipleSelection:[],
      dialogTableVisible:false,
      coupondataList:[],
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  watch:{
    $route(to,from){
      this.getList()
    }
  },
  methods: {
    couponlist(order_no){
      this.dialogTableVisible=true
        getCouponList({order_no:order_no,page:1,pageSize:100}).then(res => {
        if(res.data.data.list.length > 0) {
          this.coupondataList = res.data.data.list
        } else {
          this.coupondataList = []
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    handleCurrentChange(val) {
      this.fetchParams.page = val
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.fetchParams.page = 1
      this.fetchParams.pageSize = pageSize
      this.getList()
    },
    dateStrToTimeStamp (str) {
      return Date.parse(new Date(str))/1000
    },
    searchGoods(){
      this.fetchParams.page = 1
      this.getList()
    },
    changeSearch(){
      this.fetchParams.page = 1
      this.getList()
    },
    dateChange (val) {
      if(val) {
        if (val.length > 0) {
          this.fetchParams.begin_time = this.dateStrToTimeStamp(val[0] + ' 00:00:00')
          this.fetchParams.end_time = this.dateStrToTimeStamp(val[1] + ' 23:59:59')
        } else {
          this.fetchParams.begin_time = ''
          this.fetchParams.end_time = ''
        }
      }else{
        this.fetchParams.begin_time = ''
        this.fetchParams.end_time = ''
      }
      this.fetchParams.page = 1
      this.getList()
    },
    getList () {
      this.loading = true

      getSignList(this.fetchParams).then(res => {
        if(res.data.data.list.length > 0) {
          this.dataList = res.data.data.list
          this.pagers.total = res.data.data.total_count
          this.loading = false
        } else {
          this.dataList = []
          this.loading = false
        }
      })
        .catch( error => {
          this.loading = false
        })
    },
    del (id, index) {
      var that=this
      this.$confirm('确定要删除该商品？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            deleteSign(id).then( res => {
              if(res.status){
                this.$message({
                  message: '已删除',
                  type: 'success',
                  duration: 2000
                })
                setTimeout(function (){
                  that.dataList.splice(index, 1)
                },1000)

              }

            })
          }
          done()
        }
      })
    },
    search () {
      this.fetchParams.category_id = this.category_id
      this.getList()
    },
  },
  mounted () {
    getCategoryList({}).then(res=>{
      if(res.data){
        this.category = res.data.data
      }
    })
    this.$nextTick(() => {
      if (this.isLoad) {
        this.getList()
      }
    })
  }
}

</script>
<style scoped lang="scss">
.el-icon-edit {
  cursor: pointer;
}
.coupon-list {
  margin-top: 10px;
}
.coupon-item {
  position: relative;
  height: 130px;
  padding: 25px 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #dadadd;
  border-radius: 5px;
  text-align: center;
  font-size: 14px;
  width: 19%;
  float: left;
  margin: .5%;
  &.coupon-add {
    padding-top: 20px;
    cursor: pointer;
    i {
      font-size: 40px;
    }
    :last-child { margin-top: 10px; }
  }
  .price {
    font-size: 24px;
  }
  .color-gray {
    color: #99A9BF;
  }
  .color-gray-deep {
    color: #8492A6;
  }
  .item-code {
    display: inline-block;
    width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  span.icon-triangle {
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-top: 34px solid #20a0ff;
    border-left: 34px solid transparent;
    color: #fff;
  }
  label {
    position: absolute;
    top: -34px;
    right: 0;
    width: 20px;
    height: 20px;
    line-height: 20px;
  }
}
.item-bg {
  position: absolute;
  left: 0;
  bottom: -101%;
  width: 100%;
  height: 100%;
  background: rgba(241, 244, 246, .9);
  text-align: left;
  border-radius: 5px;
  padding-top: 8px;
  transition: all .4s ease;
  p {
    padding: 0 10px;
  }
  .item-operate {
    position: absolute;
    left: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .4);
    width: 100%;
    padding: 4px 0;
    text-align: center;
    cursor: pointer;
    a { color: #fff; }
  }
}
.coupon-item:hover {
  .item-bg {
    bottom: 0;
  }
}
.coupon-type-item {
  position: relative;
  padding: 30px 10px;
  border: 1px solid #ff5000;
  color: #ff5000;
  border-radius: 5px;
  text-align: center;
  margin-bottom: 20px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  &:first-child {
    font-size: 18px;
  }
  .coupon-type-desc {
    position: absolute;
    width: 100%;
    height: 100%;
    bottom: -100%;
    left: 0;
    padding: 10px 0;
    background: #ff5000;
    color: #fff;
    font-size: 18px;
    transition: all .4s ease;
    div:last-child {
      width: 70%;
      margin: 8px auto 0;
      font-size: 12px;
    }
  }
  &:hover {
    .coupon-type-desc {
      bottom: 0;
    }
  }
}

.coupon-type-item, .sendout-item {
  overflow: hidden;
  .icon-checked {
    display: none;
    width: 100px;
    height: 25px;
    transform: rotate(35deg);
    position: absolute;
    font-size: 14;
    top: 5px;
    right: -25px;
    font-size: 20px;
    color: #fff;
    background: #ff5000;
    i {
      transform: rotate(-35deg);
    }
  }
  &.checked {
    .icon-checked {
      display: block;
    }
  }

  &:hover .icon-checked {
    background: #fff;
    i {
      color: #ff5000;
    }
  }
}
.store-pop {
  padding: 20px 15px;
  .store-content {
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?3576f9ea